import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Secure PayPal button.
 * Nota: il totale NON viene più passato dal client — il server lo calcola
 * dal carrello memorizzato. Il client passa solo le info di spedizione.
 */
export default function PaypalButton({ shopSlug, shippingInfo, onSuccess }) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    if (!shopSlug) return;
    axios.get(`${API}/paypal/config/${shopSlug}`)
      .then(r => setCfg(r.data))
      .catch(() => setCfg({ enabled: false }));
  }, [shopSlug]);

  if (!cfg) return null;
  if (!cfg.enabled || !cfg.client_id) {
    return (
      <p data-testid="paypal-disabled-msg" className="text-[10px] text-[#877E78] text-center py-1">
        PayPal non è abilitato da questo negozio
      </p>
    );
  }

  return (
    <div data-testid="paypal-button-wrap">
      <PayPalScriptProvider
        options={{
          'client-id': cfg.client_id,
          currency: 'EUR',
          intent: 'capture',
        }}
      >
        <PayPalButtons
          style={{ layout: 'horizontal', color: 'gold', shape: 'pill', tagline: false, height: 48 }}
          createOrder={async () => {
            try {
              const { data } = await axios.post(`${API}/paypal/create-order`, {
                shipping_info: shippingInfo || {},
              }, { withCredentials: true });
              return data.id;
            } catch (e) {
              toast.error(e.response?.data?.detail || 'Errore creazione ordine PayPal');
              throw e;
            }
          }}
          onApprove={async (data) => {
            try {
              const { data: result } = await axios.post(`${API}/paypal/capture-order`, {
                order_id: data.orderID,
              }, { withCredentials: true });
              toast.success('Pagamento completato!');
              onSuccess?.(result.order);
            } catch (e) {
              toast.error(e.response?.data?.detail || 'Errore conferma pagamento');
            }
          }}
          onError={() => toast.error('Errore PayPal')}
        />
      </PayPalScriptProvider>
    </div>
  );
}
